import auth from '../../middlewares/auth';

export const workingScheduleRoutes = [
  {
    path: '/working-schedules',
    component: () =>
      import(
        /* webpackChunkName: "schedules" */ '../../views/working_schedules/WorkingSchedule'
      ),
    name: 'working-schedules',
    meta: {
      middleware: [auth],
    },
  },
  {
    path: '/working-schedule/:id',
    component: () =>
      import(
        /* webpackChunkName: "schedules" */ '../../views/working_schedules/WorkingScheduleForm'
      ),
    name: 'update-working-schedule',
    meta: {
      middleware: [auth],
    },
  },
  {
    path: '/create-working-schedule',
    component: () =>
      import(
        /* webpackChunkName: "schedules" */ '../../views/working_schedules/WorkingScheduleForm'
      ),
    name: 'create-working-schedule',
    meta: {
      middleware: [auth],
    },
  },
];
